import { Box } from "@mui/material";
import styles from "../DescriptionTabs.module.scss";

const SpecificationTab = ({ specification }) => {
    return (
        <Box className={styles.tabContent} sx={{ fontFamily: "Montserrat !important" }}>
            {(specification ?? []).map((data) => {
                return (
                    <Box key={data?.set?.id}>
                        {(Object.values(data.groups) ?? []).map((item) => {
                            return (
                                <Box key={item?.group?.id}>
                                    {(Object.values(item.attributes) ?? []).map((attribute) => {
                                        const valuesHtml = (attribute?.values ?? []).map((value) => value.name).join(", ");

                                        return (
                                            <p key={attribute?.attribute?.id} className={styles.specificationRow}>
                                                <span className={styles.specificationRowTitle} dangerouslySetInnerHTML={{ __html: attribute?.attribute?.name }} />
                                                <span className={styles.specificationRowValue} dangerouslySetInnerHTML={{ __html: valuesHtml }} />
                                            </p>
                                        );
                                    })}
                                </Box>
                            );
                        })}
                    </Box>
                );
            })}
        </Box>
    );
};

export default SpecificationTab;
